import * as React from "react"
import { List } from "immutable"
import{ Link } from "./library/link"
import { Teasers, TeaserProps } from "./teaser"

export interface ContentGridItem {
  readonly title: string
  readonly subtitle?: string
  readonly label?: string
  readonly imageAlt?: string
  readonly imageUrl?: string
  readonly videoUrl?: string
  readonly linkUrl?: string
}

export interface ContentGridBlockProps {
  title?: string
  items: List<ContentGridItem>
  row_count: number
  primaryActionTitle?: string
  primaryActionUrl?: string
}

export class ContentGridBlock extends React.Component<ContentGridBlockProps, {}> {
  render() {
    const p = this.props

    return (
      <section className="block block--content-grid">
        {(p.title && p.title != "") && (
          <header className="block__header">
            <h2 className="block__title title--l">{p.title}</h2>
          </header>
        )}

        <Teasers
          row_count={p.row_count}
          items={p.items.map<TeaserProps>((i, k) => ({
            key: `content-grid-item-${k}`,
            extraClasses: 'block__item',
            headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
            title: i.title,
            linkUrl: i.linkUrl,
            intro: i.subtitle,
            label: i.label,
            imageUrl: i.imageUrl,
            imageAlt: i.imageAlt,
            videoUrl: i.videoUrl ? i.videoUrl.replace("youtube.com", "youtube-nocookie.com") : ""
          })).toList()}
        />

        {(p.primaryActionTitle && p.primaryActionUrl) && (
          <Link className="link grid__button" url={p.primaryActionUrl}>
            {p.primaryActionTitle}
          </Link>
        )}
      </section>
    )
  }
}
